<template>
    <div
        class="payment-container"
        v-loading.fullscreen="loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <p class="payment-title">Payments</p>
        <div v-if="paymentStatus != 'success'">
            <template v-if="paymentList.length > 0">
                <div class="payment-tipbar">Payment Method</div>
                <div
                    class="payment-methods"
                    :class="{ error: paymentMethodIsRequired }"
                >
                    <div
                        class="payment-methods-item"
                        v-for="item of paymentList"
                        :key="item.label"
                    >
                        <el-radio
                            v-model="payMethod"
                            :label="item.value"
                            :disabled="item.disabled"
                            @change="payMethodChange(item)"
                        >
                            {{ item.label }}
                            <template
                                v-if="item.label == 'The Balance Payment'"
                            >
                                ( Balance :
                                <span class="balance-num"
                                    >${{ entityInfoData.balance }}</span
                                >)
                            </template>
                        </el-radio>
                    </div>
                </div>
            </template>
            <div class="table-wrapper">
                <el-table
                    ref="shippingTable"
                    :data="tableData"
                    :cell-style="cellStyle"
                    style="width: 100%"
                    header-cell-class-name="header-cell-class-name"
                    cell-class-name="cell-class-name"
                >
                    <el-table-column label="Item" width="550">
                        <template slot-scope="scope">
                            <div class="goods-info-wrapper">
                                <el-image
                                    v-if="scope.row.image"
                                    :src="scope.row.image"
                                    :preview-src-list="[scope.row.image]"
                                    fit="contain"
                                    :lazy="true"
                                ></el-image>
                                <div class="info-wrapper">
                                    <div class="goods-name ellipsis-2">
                                        {{ scope.row.goods_name }}
                                    </div>
                                    <div class="sku">
                                        <span>SKU:</span> {{ scope.row.sku }}
                                    </div>
                                    <div class="attr-value">
                                       {{ scope.row.attr_value }}
                                    </div>
                                    <template v-if="scope.row.array_mul == 1">
                                        <div
                                            class="goods-attribute"
                                            v-for="item of Object.entries(
                                                scope.row.custom_properties
                                            )"
                                            :key="item[0]"
                                        >
                                            <p class="goods-attribute-label">
                                                {{ item[0] }}:
                                            </p>
                                            <template v-if="!isImlUrl(item[1])">
                                                <el-tooltip
                                                    v-if="item[1].length > 40"
                                                    :content="item[1]"
                                                    placement="top"
                                                >
                                                    <p
                                                        class="
                                                            goods-attribute-value
                                                            ellipsis
                                                        "
                                                        v-html="item[1].replaceAll ? item[1].replaceAll('\n', '<br />') : item[1]"
                                                    ></p>
                                                </el-tooltip>
                                                <p
                                                    v-else
                                                    class="goods-attribute-value"
                                                    v-html="item[1].replaceAll ? item[1].replaceAll('\n', '<br />') : item[1]"
                                                ></p>
                                            </template>
                                            <!-- Photo -->
                                            <div class="photo_set" v-else>
                                                <el-image
                                                    v-for="item of item[1].split(
                                                        ','
                                                    )"
                                                    :key="item"
                                                    :src="item"
                                                    fit="contain"
                                                    :lazy="true"
                                                ></el-image>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="scope.row.array_mul == 2">
                                    <div
                                        v-for="(item,index) in scope.row.custom_properties"
                                        :key="index"
                                    >
                                        
                                            <div v-if="item.custom" style="padding:2px 10px;background-color:rgb(238, 242, 254);">Custom {{index+1}}</div>
                                            <div v-for="(v,k) in item.custom" :key="k"  style="padding: 5px 0 0 10px;">
                                                <div v-if="isAnImage(v)">
                                                    {{k}} : <el-image
                                                        :src="ossImg(v, 80, 80)"
                                                        :preview-src-list="[ossImg(v, 800, 800)]"
                                                        fit="contain"
                                                        :lazy="true"
                                                    ></el-image>
                                                </div>
                                                <div v-else>{{k}} : {{v}}</div>
                                            </div>
                                        
                                    </div>
                                </template>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Price">
                        <template slot-scope="scope"
                            >${{ scope.row.goods_price }}</template
                        >
                    </el-table-column>
                    <el-table-column
                        label="Quantity"
                        prop="goods_num"
                    ></el-table-column>
                    <el-table-column label="Subtotal">
                        <template slot-scope="scope"
                            >${{
                                (
                                    scope.row.goods_price * scope.row.goods_num
                                ).toFixed(2)
                            }}</template
                        >
                    </el-table-column>
                </el-table>
            </div>

            <div class="checkout-wrapper">
                <div class="checkout-box">
                    <div class="subtotal">
                        <p class="subtotal-label">Subtotal</p>
                        <p class="subtotal-value">${{ subtotal.toFixed(2) }}</p>
                    </div>
                    <div class="shipping">
                        <p class="shipping-label">Shipping</p>
                        <p class="shipping-value">${{ shipping.toFixed(2) }}</p>
                    </div>
                    <div class="discount">
                        <p class="discount-label">Discount</p>
                        <p class="discount-value">
                            {{ +discount >= 1 && `${discount}% off` || '-$' + discount.toFixed(2) }}
                        </p>
                    </div>
                    <div class="ioss" v-if="iossFee">
                        <p class="ioss-label">IOSS</p>
                        <p class="ioss-value">${{ iossFee.toFixed(2) }}</p>
                    </div>
                    <div class="insure" v-if="insureFee">
                        <p class="insure-label">Insure</p>
                        <p class="insure-value">${{ insureFee.toFixed(2) }}</p>
                    </div>
                    <el-divider></el-divider>
                    <div class="total">
                        <p class="total-label">Order Total</p>
                        <p class="total-value">${{ total.toFixed(2) }}</p>
                    </div>
                </div>
            </div>

            <div class="bottom-bar">
                <div class="checkout-btn">
                    <el-button @click="paynow">Pay Now</el-button>
                </div>
            </div>
        </div>
        <div v-else>
            <div
                class="payment-tipbar"
                :style="{ backgroundColor: paymentStatus ? '#effde9' : '' }"
            >
                <i class="el-icon-check"></i>Payment successful. Please click
                <a @click="toOrderList">#{{ order_sn }}</a> to view the order
                details
            </div>
        </div>
        <payConfirm
            :paymentVisible.sync="paymentVisible"
            @onClosed="payConfirmClosed"
            :orderId="orderId"
        ></payConfirm>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import payConfirm from "@/common/components/payConfirm.vue";

export default {
    data() {
        return {
            payMethod: "",
            paymentList: [
                {
                    label: "The Balance Payment",
                    value: "balance",
                    disabled: false,
                },
                {
                    label: "PayPal Express Checkout",
                    value: "paypal",
                    disabled: false,
                },
                /* {
                    label: "Western Union",
                    value: "WU",
                    disabled: false,
                },
                {
                    label: "Bank Transfer Payment",
                    value: "Bank",
                    disabled: false,
                }, */
            ],
            tableData: [],
            paymentStatus: "", // success 为支付成功
            order_sn: "",
            entityInfoData: {},
            paymentMethodIsRequired: false,
            loading: false,
            orderInfo: {},
            orderData: [],
            subtotal: 0,
            discount: 0,
            shipping: 0,
            iossFee: 0,
            insureFee: 0,
            orderId: "",
            paymentVisible: false,
            orderStatus: "",
        };
    },
    computed: {
        height() {
            return `calc(100% - 200px)`;
        },
        ...mapState({}),
        total() {
            // return this.subtotal + this.shipping - this.discount + this.iossFee + this.insureFee;
            return this.subtotal * (+this.discount >= 1 && (100 - +this.discount)/100 || 1) +
                +this.iossFee +
                // +this.discount +
                +this.shipping +
                +this.insureFee;
        },
    },
    components: {
        payConfirm,
    },
    watch: {},
    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 2 || columnIndex == 4) {
                return { color: "#9b3c44" };
            }
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    this.entityInfoData = res.data;
                }
            });
        },
        isAnImage(filePath){
            //获取最后一个.的位置
            var index= filePath.lastIndexOf(".");
            //获取后缀
            var ext = filePath.substr(index+1)
            return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
        },
        async initialize() {
            let { order_sn, orderId } = this.$route.query;
            this.order_sn = order_sn;
            this.orderId = orderId;
            this.orderData = JSON.parse(sessionStorage.getItem("ORDERDATA"));
            /* if (!this.orderData) {
                this.$router.replace({
                    path: "/shoppingCart",
                });
                return;
            } */
            this.tableData = this.orderData ? this.orderData : [];
            this.orderInfo = JSON.parse(sessionStorage.getItem("ORDERINFO"));
            console.log("this.orderInfo: ", this.orderInfo);
            let { subtotal, discount, shipping, iossFee, insureFee } =
                this.orderInfo;
            this.subtotal = subtotal;
            this.discount = discount;
            this.shipping = shipping;
            this.iossFee = iossFee;
            this.insureFee = insureFee;
            this.getEntityInfo();
            this.getOrderDetail();
        },
        paynow() {
            if (!this.payMethod) {
                this.paymentMethodIsRequired = true;
                return;
            }
            if (this.tableData.length == 0) {
                this.$router.replace({
                    path: "/shoppingCart",
                });
                this.$message.warning("Please select an item");
                return;
            }
            // 选择余额支付, 并账户余额小于订单金额时, 不给支付
            if(this.payMethod === "balance" && this.entityInfoData.balance < this.total){
                this.$message.error("Your balance is insufficient,please top it up.");
                return;
            }
            this.loading = true;
            cmofferApi
                .placeOrderPay(
                    {
                        order_sn: this.order_sn,
                        pay_method: this.payMethod,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        this.$ga.event("ecommerce", "payment_success");
                        this.$message.success(
                            `${this.$i18n.locale == "zh" ? "成功" : "Success"}`
                        );
                        this.getOrderDetail();
                        this.loading = false;
                        // 清空会话 购物车数据
                        sessionStorage.removeItem("ORDERDATA");
                        sessionStorage.removeItem("ORDERINFO");
                        sessionStorage.removeItem("CARTNUM");
                        sessionStorage.removeItem("ADDEDCARTNUM");
                        console.log("this.payMethod: ", this.payMethod);
                        if (this.payMethod == "paypal") {
                            this.paymentVisible = true;
                            // location.href = res.data.links[1].href;
                            window.open(res.data.links[1].href);
                        } else {
                            this.paymentStatus = "success";
                        }
                    }
                });
        },
        toOrderList() {
            this.$router.push({
                path: "/ordersList",
                query: {
                    order_sn: this.order_sn,
                },
            });
        },
        payMethodChange(val) {
            this.paymentMethodIsRequired = false;
        },
        getOrderDetail() {
            cmofferApi.orders({}, "get", this.orderId).then((res) => {
                if (res) {
                    this.orderStatus = res.data.status;
                    console.log("this.orderStatus: ", this.orderStatus);
                    // 订单状态已支付
                    if (this.orderStatus == 20) {
                        this.paymentStatus = "success";
                    }
                }
            });
        },
        payConfirmClosed() {
            this.getOrderDetail();
        },
    },
    activated() {
        this.$ga.event("ecommerce", "add_payment_info");
        this.paymentStatus = "fail";
        if (this.$route.query.status) {
            this.paymentStatus = this.$route.query.status;
        }
        this.initialize();
    },
    deactivated() {
        this.paymentStatus = "";
        this.payMethod = "";
    },
};
</script>

<style lang="scss" scoped>
.payment-container {
    padding: 15px 30px 110px;
    width: 100%;
    // height: 100%;
    box-sizing: border-box;
    text-align: left;
    .payment-title {
        font-size: 30px;
        font-weight: 600;
        letter-spacing: 1px;
    }
    .payment-tipbar {
        background-color: #f3f3f3;
        padding: 8px 20px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 26px;
        font-size: 13px;
        color: $color-333333;
        margin: 20px 0;
        a {
            font-weight: 800;
            color: $color-primary-blue;
        }
        i {
            font-weight: 600;
            font-size: 14px;
            margin-right: 10px;
        }
    }
    .payment-methods {
        display: table;
        flex-wrap: wrap;
        padding: 5px;
        border: 1px solid transparent;
        .payment-methods-item {
            font-size: 13px;
            height: 30px;
            line-height: 30px;
            margin-bottom: 5px;
            .balance-num {
                font-weight: bold;
            }
        }
    }
    .table-wrapper {
        margin: 30px 0 40px;
        ::v-deep .header-cell-class-name {
            background-color: transparent;
            font-size: 14px;
            color: $color-333333 !important;
        }
        ::v-deep .cell-class-name {
            vertical-align: top;
            font-size: 14px;
            .el-input-number {
                width: 120px;
            }
            .el-icon-delete {
                font-size: 20px;
                cursor: pointer;
                &:active {
                    opacity: 0.6;
                }
            }
        }
        .goods-info-wrapper {
            display: flex;
            ::v-deep .el-image {
                width: 100px;
                height: 100px;
                flex-shrink: 0;
                & + .el-image {
                    margin-left: 5px;
                }
            }
            .info-wrapper {
                margin-left: 20px;
                font-size: 13px;
                .goods-name {
                    // width: 75%;
                    color: $color-333333;
                    margin-bottom: 10px;
                }
                .sku,.attr-value {
                    & span:first-of-type {
                        color: $color-333333;
                        margin-right: 10px;
                    }
                    color: #000000;
                }
                .goods-attribute {
                    // margin-top: 5px;
                    font-size: 13px;
                    display: flex;
                    color: $color-333333;
                    .goods-attribute-label {
                        margin-right: 10px;
                        flex-shrink: 0;
                    }
                    .goods-attribute-value {
                        color: #000000;
                    }
                }
                .photo_set {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-around;
                    /* & + .el-image {
                    margin-left: 5px;
                } */
                }
            }
        }
    }
    .checkout-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        padding-bottom: 60px;
        .checkout-box {
            min-width: 250px;
            max-width: 300px;
            padding: 10px;
            > div:not(:last-child) {
                margin-bottom: 20px;
            }
            .subtotal,
            .shipping,
            .discount,
            .ioss,
            .insure {
                font-size: 13px;
                display: flex;
                justify-content: space-between;
                &-label {
                    color: $color-808080;
                }
                &-value {
                    // color: #9b3c44;
                    color: $color-333333;
                }
            }
            .discount {
                &-value {
                    color: #9b3c44;
                }
            }
            .total {
                font-size: 16px;
                display: flex;
                justify-content: space-between;
                .total-label {
                    color: $color-333333;
                }
                .total-value {
                    color: #9b3c44;
                }
            }
            .tip {
                color: $color-333333;
                font-size: 15px;
                line-height: 22px;
            }
            .subtip {
                margin-top: 20px;
                color: #666;
                font-size: 14px;
                font-style: italic;
                line-height: 20px;
                text-align: right;
            }
        }
    }
    .bottom-bar {
        position: fixed;
        width: calc(100% - 201px);
        bottom: 0;
        right: 0;
        height: 85px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background-color: #f6f6f7;
        z-index: 100;
        padding: 0 40px 0 20px;
        box-sizing: border-box;
        .checkout-btn {
            width: 320px;
            z-index: 100;
            display: flex;
            align-items: center;
            justify-content: center;

            .el-button {
                width: 100%;
                height: 50px;
                // border-radius: 4px;
                background-color: $color-primary;
                text-align: center;
                cursor: pointer;
                color: #ffffff;
                button {
                    color: #fff;
                    font-size: 16px;
                    border: none;
                    outline: none;
                    background-color: transparent;
                }
                &:hover {
                    opacity: 0.95;
                }
                &:active {
                    opacity: 0.85;
                }
            }
        }
    }
}
</style>
